import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cashPoolService } from '@/services/cash-pool/cash-pool-service';
import { cashPoolKeys } from '@/services/query-keys/cash-pool-keys';
import { CashPoolFormData } from '@/types/cash-pool.types';

export const useUpdateCashPool = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: CashPoolFormData }) =>
      cashPoolService.updateCashPool(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: cashPoolKeys.all });
    },
  });
};
